import React from "react";
import styled from "styled-components";
import { tokens } from "../../public/tokens";

const tones = {
    naartjie: {
        bg: tokens.colors.brand.naartjie["100"],
        fg: tokens.colors.brand.naartjie["800"],
    },
    tideBlue: {
        bg: tokens.colors.brand["tide-blue"]["100"],
        fg: tokens.colors.brand["tide-blue"]["700"],
    },
    veldSprout: {
        bg: tokens.colors.brand["veld-sprout"]["100"],
        fg: tokens.colors.brand["veld-sprout"]["700"],
    },
    blue: {
        bg: tokens.colors.brand.blue["50"],
        fg: tokens.colors.brand.blue["500"],
    },
    success: {
        bg: tokens.colors.states.success["100"],
        fg: tokens.colors.states.success["800"],
    },
    grey: {
        bg: tokens.colors.neutral.grey.Alpha["10"],
        fg: tokens.colors.text.secondary,
    },
    warning: {
        bg: tokens.colors.states.warning["100"],
        fg: tokens.colors.states.warning["800"],
    },
    warningSolid: {
        bg: tokens.colors.states.warning["500"],
        fg: tokens.colors.neutral.white,
    },
    attention: {
        bg: tokens.colors.states.warning["100"],
        fg: tokens.colors.states.warning["800"],
    },
    destructive: {
        bg: tokens.colors.states.alert["100"],
        fg: tokens.colors.ui.destructive,
    },
    plain: {
        bg: "transparent",
        fg: tokens.colors.text.secondary,
    },
};

const StyledBadge = styled.span(({ $tone = "grey" }) => {
    const { bg, fg } = tones[$tone] || tones.grey;
    return {
        display: "inline-flex",
        alignItems: "center",
        gap: tokens.globals["spacing-1"],
        minHeight: "18px",
        padding: bg === "transparent"
            ? `${tokens.globals["spacing-0-5"]} 0`
            : `${tokens.globals["spacing-1"]} ${tokens.globals["spacing-2"]}`,
        borderRadius: tokens.globals["border-radius"],
        background: bg,
        color: fg,
        maxWidth: "100%",
    };
});

const StyledIcon = styled.i({
    color: "currentColor",
    fontSize: tokens.typography.fontSize["sm-10px"],
    lineHeight: "10px",
    flexShrink: 0,
});

const StyledLabel = styled.span({
    color: "currentColor",
    fontSize: tokens.typography.fontSize["sm-10px"],
    fontFamily: tokens.typography.fontFamilies["albert-sans"],
    fontWeight: tokens.typography.fontWeights.semibold,
    lineHeight: "10px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
});

/**
 * Small status/label pill used for tags, campus badges, version status, etc. e.g. "Credits: 70/0", "Locked", "No Study Path".
 * @param {"naartjie"|"tideBlue"|"veldSprout"|"blue"|"grey"|"warning"|"warningSolid"|"attention"|"success"|"destructive"|"plain"} [props.tone="grey"] - Colour tone.
 * @param {string} [props.icon] - Optional Font Awesome icon name (rendered `fal fa-{icon}`).
 * Also: children, className, title (self-explanatory).
 */
function Badge({ tone = "grey", icon, children, className, title, ...props }) {
    return (
        <StyledBadge $tone={tone} className={className} title={title} {...props}>
            {icon && <StyledIcon className={`fal fa-${icon}`} aria-hidden="true" />}
            <StyledLabel>{children}</StyledLabel>
        </StyledBadge>
    );
}

Badge.displayName = "Badge";

export default Badge;
